import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 10;

function TaxonomySection({ title, endpoint }) {
  const [items, setItems] = useState([]);
  // Lista completa, sem paginacao, so para o seletor de "Pai": paginada, ela
  // ofereceria apenas os itens da pagina atual como possiveis pais.
  const [allItems, setAllItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', code: '', parent_id: '' });
  const [error, setError] = useState('');

  useEffect(() => { load(); }, [page, search]);
  async function load() {
    const [paged, all] = await Promise.all([
      api.get(`/${endpoint}`, { params: { page, limit: PAGE_SIZE, search: search || undefined } }),
      api.get(`/${endpoint}`),
    ]);
    setItems(paged.data.data);
    setTotal(paged.data.total);
    setAllItems(all.data.data);
  }

  async function handleSave() {
    setError('');
    try {
      const payload = { ...form, parent_id: form.parent_id || null };
      if (editing) { await api.put(`/${endpoint}/${editing.id}`, payload); } else { await api.post(`/${endpoint}`, payload); }
      setShowModal(false); load();
    } catch (err) { setError(err.response?.data?.error || 'Erro'); }
  }
  async function handleDelete(id) { if (!window.confirm('Excluir?')) return; try { await api.delete(`/${endpoint}/${id}`); load(); } catch (err) { alert(err.response?.data?.error); } }

  return (
    <div className="bg-surface-100 border rounded-md p-4 mb-4">
      <div className="flex items-center justify-between mb-4 pb-3 border-b border-subtle">
        <h3 className="text-base font-semibold">{title}</h3>
        <button className="btn btn-sm btn-primary" onClick={() => { setEditing(null); setForm({ name: '', code: '', parent_id: '' }); setError(''); setShowModal(true); }}>Novo</button>
      </div>
      <input
        className="form-input mb-3 max-w-[280px]"
        placeholder="Buscar por nome ou código..."
        value={search}
        onChange={(e) => { setSearch(e.target.value); setPage(1); }}
      />
      <table className="w-full border-collapse">
        <thead><tr className="border-b">
          <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Código</th>
          <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Nome</th>
          <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Ações</th>
        </tr></thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className="border-b border-subtle hover:bg-surface-inset">
              <td className="px-3 py-3"><span className="doc-code">{item.code}</span></td>
              <td className="px-3 py-3">{item.name}</td>
              <td className="px-3 py-3"><div className="flex gap-1">
                <button className="btn btn-sm btn-secondary" onClick={() => { setEditing(item); setForm({ name: item.name, code: item.code, parent_id: item.parent_id || '' }); setError(''); setShowModal(true); }}>Editar</button>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Excluir</button>
              </div></td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination page={page} total={total} limit={PAGE_SIZE} onPageChange={setPage} />
      {showModal && (
        <Modal title={editing ? `Editar ${title}` : `Novo ${title}`} onClose={() => setShowModal(false)}>
          {error && <div className="p-3 rounded-md text-sm mb-4 bg-status-rejected/10 text-status-rejected border border-status-rejected/20">{error}</div>}
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Nome</label>
            <input className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Código (max 4 caracteres)</label>
            <input className="form-input" value={form.code} maxLength={4} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} /></div>
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Pai (opcional)</label>
            <select className="form-select" value={form.parent_id} onChange={(e) => setForm({ ...form, parent_id: e.target.value })}>
              <option value="">Nenhum</option>
              {allItems.filter((i) => i.id !== editing?.id).map((i) => <option key={i.id} value={i.id}>{i.name} ({i.code})</option>)}
            </select></div>
          <div className="flex gap-3 justify-end mt-5">
            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSave}>Salvar</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default function Taxonomy() {
  return (
    <div>
      <div className="flex items-center justify-between mb-6"><h1 className="text-xl font-bold tracking-tight">Taxonomia</h1></div>
      <TaxonomySection title="Departamentos" endpoint="departments" />
      <TaxonomySection title="Categorias" endpoint="categories" />
      <TaxonomySection title="Processos" endpoint="processes" />
    </div>
  );
}
